import React, { useState, useEffect } from "react";
import logo from "../assets/altus-ventures-logo_white.png";
import "./footer.css";
import Modal from "./Modal";

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  // the use effect hook removes scrolling on the webpage if the modal is opem
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  return (
    <div className="footer">
      <img className="altus-footer-logo" src={logo} alt="" />{" "}
      <div className="footer-link-text">
        <small>Altus Ventures Ltd&nbsp;</small>
        <small>
          Unit 09.201, The Leathermarket, Weston Street, London
          SE1&nbsp;3ER&nbsp;
        </small>
        <small className="footer-link" onClick={() => setIsOpen(true)}>
          Privacy Policy&nbsp;
        </small>
        <small>© Altus Ventures Limited </small>
      </div>
      <Modal open={isOpen} onClose={() => setIsOpen(false)}></Modal>
    </div>
  );
};

export default Footer;
